@use "variables" as *;

.skeleton {
  width: 100%;
  border-radius: 20px;
}
